import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CedProductService } from "app/management/ced-products/ced-product.service";
import { CommonService } from "app/reusable/common.service";
import { CaseDetailLabels } from "app/_models/Case-Detail-Labels-model";
import { CaseType } from "app/_models/case-type/add-edit-case-type.model";
import { LocationType } from "app/_models/location-type.model";
import { CedNotificationService } from "ced-ng-library";
import { environment } from "environments/environment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DossierAssignmentTypeService } from "../DossierAssignmentTypeService";
import { MDMService } from "app/reusable/mdm.service";
import { CASE_TYPE } from "app/_constants/caseDetails";

@Component({
  selector: "app-case-type-details",
  templateUrl: "case-type-details.component.html",
  styleUrls: ["case-type-details.component.scss"],
})

export class CaseTypeDetailsComponent implements OnInit, OnDestroy {
  dropdownValues = ["Yes", "No"];
  public caseTypeForm: FormGroup;
  public caseType = new CaseType();
  public locationGrid: LocationType[] = [];
  public checkedKeys: any[] = [];
  public disabled: boolean = true;
  public serverUrlSlot3 : string = environment.Services.AlphaURLSlot3;
  public selectedOtherCaseType: any;
  public otherCaseTypeList: any[] = [];
  dataSource = [];
  helpPlanTypes;
  helpPlanTypeslist;
  private _subject$: Subject<boolean> = new Subject();
  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() id: string;
  @Input() copyMode: boolean = false;
  public list: any[] = [];
  public activePublishedCaseTypeList: any[] = [];
  public isGeneral: boolean;
  policycontrollist = [];
  public labels = [
    { name: "Label 1", isSelected: false },
    { name: "Label 2", isSelected: false },
    { name: "Label 3", isSelected: false },
    { name: "Label 4", isSelected: false },
  ];
  disableActive: boolean = false;

  public labelForm: FormGroup = new FormGroup({
    cdlLabel1: new FormControl(
      { value: "", disabled: !this.labels[0].isSelected },
      Validators.required
    ),
    cdlLabel2: new FormControl(
      { value: "", disabled: !this.labels[1].isSelected },
      Validators.required
    ),
    cdlLabel3: new FormControl(
      { value: "", disabled: !this.labels[2].isSelected },
      Validators.required
    ),
    cdlLabel4: new FormControl(
      { value: "", disabled: !this.labels[3].isSelected },
      Validators.required
    ),
  });
  cdId: string;
  caseDetailLabels = new CaseDetailLabels();
  caseTypeData: any;
  dislpayDetails = false;
  rehospitalisationValue = false;
  adlValue = false;
  dbcValue = false;
  assignmentTypes = [];
  cedProducts = [];
  switchCaseType : boolean = false;

  constructor(
    private commonService: CommonService,
    private cedProductService : CedProductService,
    private dossierAssignmentTypeService: DossierAssignmentTypeService,
    private cedNotificationService: CedNotificationService,
    private mdmService: MDMService
  ) {
    this.getOrganizationUnit();
    this.dossierAssignmentTypes();
    this.getActiveCedProducts();
   }

   getOrganizationUnit(): void {
    const GetClientsListUrl: string = `api/OrganizationUnit/GetInsurersAndMandates`;
    this.mdmService
      .getData(GetClientsListUrl, true)
      .pipe(takeUntil(this._subject$))
      .subscribe(
        (data: any) => {
          this.dataSource = data;
          this.dataSource = this.dataSource
            .filter((cl) => cl.shortName != null && cl.shortName != "")
            .sort((a, b) =>
              a.shortName.toLowerCase() > b.shortName.toLowerCase() ? 1 : -1
            );
        },
        (error) => {
          this.cedNotificationService.warning("NOTIFICATIONS.GET_ORGANIZATION_UNIT");
        }
      );
  }

  toggleSelectAll(): void {
    const control = this.caseTypeForm.get('ctySwitchCaseTypes');
    if (control.value.length === this.dataSource.length) {
      control.setValue([]);
    } 
    else {
      const allValues = this.dataSource.map(item => ({
        id: item.id,
        idCaseTypeOu : null,
        organizationunitId: item.organizationunitId ? item.organizationunitId : item.id,
        caseTypeId: item.caseTypeId ? item.caseTypeId : this.caseTypeData.ctyId
      }));
      control.setValue(allValues);
    }
  }

  ngOnInit() {
    this.initForm();
    this.getActivePublishedCaseType();
    this.id ? this.getCaseTypeById() : (this.dislpayDetails = true);
  }

  checkSelectCaseType(caseType) : boolean{
    return caseType.ctyName == CASE_TYPE.ZIEKTE || caseType.ctyName == CASE_TYPE.ONGEVAL || caseType.ctyName == CASE_TYPE.PLANBAREZORG;
  }  

  dossierAssignmentTypes(){
    this.dossierAssignmentTypeService
    .getAll()
    .pipe(takeUntil(this._subject$))
    .subscribe((data) => {
      this.assignmentTypes = data;
    },
    (error) => {
      this.cedNotificationService.warning("NOTIFICATIONS.GET_DATA");
    });
  }

  getActiveCedProducts(){
    this.cedProductService
    .getActiveCedProducts()
    .pipe(takeUntil(this._subject$))
    .subscribe((data:any) => {
      this.cedProducts = data;
    },
    (error) => {
      this.cedNotificationService.warning("NOTIFICATIONS.GET_PRODUCT");
    });
  }

  public getActivePublishedCaseType(){
    const getCaseTypesUrl: string = `CaseType/GetActivePublishedCaseTypes`;
    this.commonService.getData(getCaseTypesUrl, this.serverUrlSlot3,true)
    .subscribe((res: any[]) => {
      this.activePublishedCaseTypeList = res.filter(ct=>ct.ctyId!=this.id);
      if(this.otherCaseTypeList.length > 0){
        this.otherCaseTypeList.forEach(element => {
          let index = this.activePublishedCaseTypeList.findIndex(
            (cty) => cty.ctyId === element.ctyId
          );
          this.checkedKeys.push(index.toString());
        });
      }
    },
    (error) => {
      this.cedNotificationService.warning("NOTIFICATIONS.GET_DATA");
    });
  }

  private getCaseTypeById() {
    this.disableActive = false;
    this.labelForm.patchValue(this.caseDetailLabels);
    let getCaseTypeByIdUrl = `CaseType/GetById/${this.id}`;
    this.commonService
      .getData(getCaseTypeByIdUrl, this.serverUrlSlot3)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        this.caseTypeData = data as CaseType;  
        this.switchCaseType = this.checkSelectCaseType(this.caseTypeData);
        let caseTypeOrganizationUnits = [];
        if(this.caseTypeData.caseTypeOrganizationUnits.length > 0){
          caseTypeOrganizationUnits = this.caseTypeData.caseTypeOrganizationUnits.map(element => {
          const item = this.dataSource.find(x => x.id === element.organizationUnitId);
          if (item) {
            return {
              ...item,
              idCaseTypeOu: element.id
            };
          }
          return null;
        }).filter(item => item !== null);
     }
      this.caseTypeForm.controls.ctySwitchCaseTypes.setValue(caseTypeOrganizationUnits);
       
           if(this.caseTypeData.ctyIsActive == true)
          {
            this.caseTypeData.ctyIsActive ="Yes";
          }
          else{
             this.caseTypeData.ctyIsActive  ="No";
          }
          if(this.caseTypeData.ctyIsPublished == true)
          {
            this.caseTypeData.ctyIsPublished ="Yes";
          }
          else{
             this.caseTypeData.ctyIsPublished  ="No";
          }
          if(this.caseTypeData.ctyIsAutomaticActions == true)
          {
            this.caseTypeData.ctyIsAutomaticActions ="Yes";
            this.caseTypeForm.controls.ctyAutomaticActions.setValue("Yes")

          }
          else{
             this.caseTypeData.ctyIsAutomaticActions  ="No";
             this.caseTypeForm.controls.ctyAutomaticActions.setValue("No")
          }
        this.rehospitalisationValue =  this.caseTypeData.ctyHasRehospitalisation
        if(this.copyMode == false && this.caseTypeData.ctyHasLinkedDossier)
        {
          this.caseTypeForm.get("ctyHasTravelDetails").disable();
          this.caseTypeForm.get("ctyHasRehospitalisation").disable();
          this.caseTypeForm.get("ctyHasAdl").disable();
          this.caseTypeForm.get("ctyHasDbc").disable();
          this.caseTypeForm.get("ctyHasFellowTravellers").disable();
          this.caseTypeForm.get("ctyHasPiaPolicy").disable();
          this.caseTypeForm.get("ctyHasVecozoPolicy").disable();
          this.caseTypeForm.get("insuree").disable();
          this.caseTypeForm.get("Summary").disable();
        }
        if (this.copyMode == true) {
          this.caseTypeData.ctyCode = null;
          this.caseTypeData.ctyName = null;
          this.cdId = data.ctyCaseDetailId;
          this.caseType.helpPlans = data.helpPlans;
          this.caseType.helpPlanTypes = data.helpPlanTypes;
          this.caseType.locations = data.locations;
          this.caseType.clientPolicyControlExceptions = data.clientPolicyControlExceptions;
          this.caseType.ctyDossierProductId = data.ctyDossierProductId;
          if (data.caseDetailLabel != null) {
            this.caseDetailLabels = data.caseDetailLabel;
            if (this.caseDetailLabels.cdlLabel1 != "") {
              this.labels[0].isSelected = true;
              this.labelForm.controls["cdlLabel1"].patchValue(
                this.caseDetailLabels.cdlLabel1
              );
              this.labelForm.controls["cdlLabel1"].enable();
            }
            if (this.caseDetailLabels.cdlLabel2 != "") {
              this.labelForm.controls["cdlLabel2"].patchValue(
                this.caseDetailLabels.cdlLabel2
              );
              this.labels[1].isSelected = true;
              this.labelForm.controls["cdlLabel2"].enable();
            }
            if (this.caseDetailLabels.cdlLabel3 != "") {
              this.labelForm.controls["cdlLabel3"].patchValue(
                this.caseDetailLabels.cdlLabel3
              );
              this.labels[2].isSelected = true;
              this.labelForm.controls["cdlLabel3"].enable();
            }
            if (this.caseDetailLabels.cdlLabel4 != "") {
              this.labelForm.controls["cdlLabel4"].patchValue(
                this.caseDetailLabels.cdlLabel4
              );
              this.labels[3].isSelected = true;
              this.labelForm.controls["cdlLabel4"].enable();
            }
          }
          this.caseTypeForm.patchValue(this.caseTypeData);
          this.dislpayDetails = true;
        }
        else {
          this.cdId = data.ctyCaseDetailId;
          this.caseType.helpPlans = data.helpPlans;
          this.caseType.helpPlanTypes = data.helpPlanTypes;
          this.caseType.locations = data.locations;
          this.caseType.clientPolicyControlExceptions = data.clientPolicyControlExceptions;
          if (data.caseDetailLabel != null) {
            this.caseDetailLabels = data.caseDetailLabel;
            if (this.caseDetailLabels.cdlLabel1 != "") {
              this.labels[0].isSelected = true;
              this.labelForm.controls["cdlLabel1"].patchValue(
                this.caseDetailLabels.cdlLabel1
              );
              this.labelForm.controls["cdlLabel1"].enable();
            }

            if (this.caseDetailLabels.cdlLabel2 != "") {
              this.labelForm.controls["cdlLabel2"].patchValue(
                this.caseDetailLabels.cdlLabel2
              );
              this.labels[1].isSelected = true;
              this.labelForm.controls["cdlLabel2"].enable();
            }
            if (this.caseDetailLabels.cdlLabel3 != "") {
              this.labelForm.controls["cdlLabel3"].patchValue(
                this.caseDetailLabels.cdlLabel3
              );
              this.labels[2].isSelected = true;
              this.labelForm.controls["cdlLabel3"].enable();
            }
            if (this.caseDetailLabels.cdlLabel4 != "") {
              this.labelForm.controls["cdlLabel4"].patchValue(
                this.caseDetailLabels.cdlLabel4
              );
              this.labels[3].isSelected = true;
              this.labelForm.controls["cdlLabel4"].enable();
            }
          }
        }
        this.caseTypeForm.patchValue(this.caseTypeData);
        this.otherCaseTypeList = data.linkedCaseTypes;
        if(this.activePublishedCaseTypeList.length > 0){
          this.otherCaseTypeList.forEach(element => {
            let index = this.activePublishedCaseTypeList.findIndex(
              (cty) => cty.ctyId === element.ctyId
            );
            this.checkedKeys.push(index.toString());
          });
        }
        let cedProduct = this.cedProducts.find(x=>x.prdId == this.caseTypeData.ctyDossierProductId);
        this.caseTypeForm.controls.cedProduct.setValue(cedProduct != undefined ? cedProduct: null);
        this.dislpayDetails = true;
      },
      (error) => {
        this.cedNotificationService.warning("NOTIFICATIONS.GET_CASE");
      });
  }
  checkExist(index){

    return this.checkedKeys.filter(k=>k == index).length>0;
  }
  private initForm() {
    this.disableActive = true;
    this.caseTypeForm = new FormGroup({
      ctyCode: new FormControl(""),
      ctyName: new FormControl("", [Validators.required]),
      ctyHasPiaPolicy: new FormControl(false),
      ctyHasVecozoPolicy: new FormControl(false),
      ctyIsActive: new FormControl("Yes", Validators.required),
      ctyIsPublished: new FormControl("No", Validators.required),
      ctyAutomaticActions: new FormControl("",Validators.required),
      ctyHasTravelDetails: new FormControl(false),
      ctyHasRehospitalisation: new FormControl(false),
      ctyHasAdl: new FormControl(false),
      ctyHasDbc: new FormControl(false),
      ctyHasFellowTravellers: new FormControl(false),
      ctyDescription: new FormControl(""),
      insuree: new FormControl(true),
      caseDetails: new FormControl(true),
      location: new FormControl(true),
      helpPlans: new FormControl(true),
      linkedCaseTypes: new FormControl(true),
      Summary: new FormControl(true),
      cedProduct :new FormControl("", Validators.required),
      ctySwitchCaseTypes: new FormControl([]),
    });
  }


  public casedetailId(event) {
    this.caseType.ctyCaseDetailId = event.cdId;
    this.isGeneral = event.isGeneral;
  }

  public getCasedetailLabels(event) {
    this.labelForm = event;
    if (this.labelForm.invalid) {
    } else {
      this.caseDetailLabels.cdlLabel1 = event.getRawValue().cdlLabel1;
      this.caseDetailLabels.cdlLabel2 = event.getRawValue().cdlLabel2;
      this.caseDetailLabels.cdlLabel3 = event.getRawValue().cdlLabel3;
      this.caseDetailLabels.cdlLabel4 = event.getRawValue().cdlLabel4;
    }
  }

  public policycontrols(event) {
    this.caseType.clientPolicyControlExceptions = event;
  }

  public getLocationGrid(event) {
    this.locationGrid = event;
  }

  public locations(event) {
    this.caseType.locations = event;
  }

  changeRehospitalisationValue(event) {
    this.rehospitalisationValue = event.target.checked;
    if (this.rehospitalisationValue) {
      if (this.locationGrid.length != 0) {
        this.caseType.locations = this.locationGrid.filter(
          (l) => l.lctName == "Rehospitalisation" || l.lctName == "Heropname"
        );
      }
    } else {
      if (this.caseType.locations.length != 0) {
        this.caseType.locations.forEach((el, i) => {
          if (el.lctName == "Rehospitalisation" || el.lctName == "Heropname") {
            this.caseType.locations.splice(i, 1);
          }
        });
      }
    }
  }

  changeAdlValue(event){
    this.adlValue = event.target.checked;
  }

  getselectedItem(event,dataItem,index): void {
  this.selectedOtherCaseType = dataItem;
  if(event.target.checked)
  this.otherCaseTypeList = [...this.otherCaseTypeList,this.selectedOtherCaseType];
  else
  this.otherCaseTypeList.splice( this.otherCaseTypeList.findIndex(c=> c.ctyId == dataItem.ctyId),1);
  }
  changeDbcValue(event){
    this.dbcValue = event.target.checked;
  }

  public saveCaseType(caseTypeFormValue) {
    if (this.caseTypeForm.valid) {
      this.ExecuteCaseTypeCreation(caseTypeFormValue);
    }
    if (this.caseTypeForm.invalid) {
      this.cedNotificationService.error("NOTIFICATIONS.REQUIRED_DATA_MISSING")
    }
  }

  private ExecuteCaseTypeCreation = (caseTypeFormValue) => {
    this.caseType.ctyName = caseTypeFormValue.ctyName;
    this.caseType.ctyHasPiaPolicy = caseTypeFormValue.ctyHasPiaPolicy;
    this.caseType.ctyHasVecozoPolicy = caseTypeFormValue.ctyHasVecozoPolicy;
    this.caseType.ctyIsActive = caseTypeFormValue.ctyIsActive =="Yes" ? true : false;
    this.caseType.ctyIsPublished = caseTypeFormValue.ctyIsPublished =="Yes" ? true : false;
    this.caseType.ctyPublishedOn = caseTypeFormValue.ctyPublishedOn;
    this.caseType.ctyHasTravelDetails = caseTypeFormValue.ctyHasTravelDetails;
    this.caseType.ctyHasRehospitalisation = caseTypeFormValue.ctyHasRehospitalisation;
    this.caseType.ctyHasAdl = caseTypeFormValue.ctyHasAdl;
    this.caseType.ctyHasDbc = caseTypeFormValue.ctyHasDbc;
    this.caseType.ctyHasFellowTravellers =caseTypeFormValue.ctyHasFellowTravellers;
    this.caseType.ctyDescription = caseTypeFormValue.ctyDescription;
    this.caseType.ctyIsAutomaticActions = caseTypeFormValue.ctyAutomaticActions =="Yes" ? true : false;
    this.caseType.linkedCaseTypes = this.otherCaseTypeList;
    this.caseType.locations = this.caseType.locations.map(function (item) {
      delete item.lctIsSelected;
      return item;
    });
    let assignmentType = this.assignmentTypes.find(x=>x.fatCode == "CP");
    if(assignmentType != null && assignmentType != undefined){
      this.caseType.ctyDossierAssignmentTypeId = assignmentType.fatId;
    }
    this.caseType.ctyDossierProductId = caseTypeFormValue.cedProduct.prdId;
    this.caseType.caseTypeOrganizationUnits = caseTypeFormValue.ctySwitchCaseTypes.map(x => ({
          id : x.idCaseTypeOu,
          organizationunitId: x.organizationunitId ? x.organizationunitId : x.id,
          caseTypeId: x.caseTypeId ? x.caseTypeId : this.caseTypeData.ctyId,
        }));
    if (
      caseTypeFormValue.ctyHasPiaPolicy == false &&
      caseTypeFormValue.ctyHasVecozoPolicy == false
    ) {
      this.cedNotificationService.error("NOTIFICATIONS.VECOZO_NEEDS_TO_BE_CHECKED")
    }
    if (this.caseType.ctyCaseDetailId == undefined) {
      this.cedNotificationService.error("NOTIFICATIONS.NO_CASEDETAILS_SELECTED");
    }

    if (this.isGeneral == true && (this.labelForm.invalid || (this.labels[0].isSelected == false && this.labels[1].isSelected == false && this.labels[2].isSelected == false && this.labels[3].isSelected == false))) {
      this.cedNotificationService.error("NOTIFICATIONS.GENERAL_LABEL_MISSING");
    }
    if (this.caseType.locations.length < 1) {
      this.cedNotificationService.error("NOTIFICATIONS.NO_LOCATIONTYPE_SELECTED");
    }
    if (this.caseType.helpPlans.length < 1) {
      this.cedNotificationService.error("NOTIFICATIONS.NO_HELP_PLAN_SELECTED");
    }
    if (this.caseType.helpPlanTypes.length < 1) {
      this.cedNotificationService.error("NOTIFICATIONS.NO_HELP_PLAN_TYPE_SELECTED");
    }
    if (this.isGeneral == true && this.labelForm.valid) {
      if (this.id != undefined && this.copyMode == true){
        let caseDetailToCopy= {
          cdlId: "",
          cdlCaseTypeId:"",
          cdlLabel1:this.caseDetailLabels.cdlLabel1,
          cdlLabel2:this.caseDetailLabels.cdlLabel2,
          cdlLabel3:this.caseDetailLabels.cdlLabel3,
          cdlLabel4:this.caseDetailLabels.cdlLabel4
        }
        this.caseType.caseDetailLabel = caseDetailToCopy;
      }
      else
        this.caseType.caseDetailLabel = this.caseDetailLabels;

    }
    if (
      (caseTypeFormValue.ctyHasPiaPolicy == true ||
        caseTypeFormValue.ctyHasVecozoPolicy == true) &&
      this.caseType.ctyCaseDetailId != undefined &&
      (this.isGeneral == false ||
        (this.isGeneral == true && this.labelForm.valid))
      && this.caseType.locations.length >= 1
      && this.caseType.helpPlans.length >= 1
      && this.caseType.helpPlanTypes.length >= 1
    ) {
      if (this.id != undefined && this.copyMode == false) {
        this.caseType.ctyId = this.id;
        this.caseType.ctyCode = caseTypeFormValue.ctyCode;
        let UpdateCaseTypeUrl: string = `CaseType/Update`;
        this.commonService
          .update(UpdateCaseTypeUrl, this.caseType)
          .pipe(takeUntil(this._subject$))
          .subscribe((res) => {
            let result: any = res;
            let caseType = result.caseType;
            if (result.isSuccessful == true) {
              this.cedNotificationService.success("NOTIFICATIONS.DATA_UPDATED");
              this.save.emit({ casetype: caseType, editMode: true });
              this.close();
            } else if (result.isSuccessful == false) {
              let ErrorMessage = result.errorMessage;
              this.cedNotificationService.error(ErrorMessage);
            }
          },
          (error) => {
            this.cedNotificationService.warning("NOTIFICATIONS.GET_CASE");
          });
      }
      else if (this.id != undefined && this.copyMode == true) {
        this.caseType.clientPolicyControlExceptions.forEach(el => el.cpcOrganizationunit = el.cpcId = el.cpcCaseTypeId = null);
        let PostCaseTypeUrl: string = `CaseType/Post`;
        this.commonService
          .create(PostCaseTypeUrl, this.caseType)
          .pipe(takeUntil(this._subject$)).subscribe((res) => {
            let result: any = res;
            let caseType = result.caseType;
            if (result.isSuccessful == true) {
              this.cedNotificationService.success("NOTIFICATIONS.DATA_SAVED");
              this.save.emit({ casetype: caseType, editMode: false });
              this.close();
            } else if (result.isSuccessful == false) {
              let ErrorMessage = result.errorMessage;
              this.cedNotificationService.error(ErrorMessage);
            }
          },
          (error) => {
            this.cedNotificationService.warning("NOTIFICATIONS.GET_CASE");
          });
      }
      else {
        let PostCaseTypeUrl: string = `CaseType/Post`;
        this.commonService
          .create(PostCaseTypeUrl, this.caseType)
          .pipe(takeUntil(this._subject$)).subscribe((res) => {
            let result: any = res;
            let caseType = result.caseType;
            if (result.isSuccessful == true) {
              this.cedNotificationService.success("NOTIFICATIONS.DATA_SAVED");
              this.save.emit({ casetype: caseType, editMode: false });
              this.close();
            } else if (result.isSuccessful == false) {
              let ErrorMessage = result.errorMessage;
              this.cedNotificationService.error(ErrorMessage);
            }
          });
      }
    }
  };

  /************************************
   ***     Help Plan Method        ***
   ***********************************/
  changeHelpPlanType($event): void {
    this.caseType.helpPlanTypes = $event;
  }

  changeIntakePlan($event) {
    this.caseType.helpPlans = $event;
  }

  /******************************** */
  close() {
    this.cancel.emit(true);
  }

  ngOnDestroy(): void {
    this._subject$.unsubscribe();
  }
}